import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthStateService {

  private userSubject = new BehaviorSubject<any>(this.getStoredUser());
  user$ = this.userSubject.asObservable();

  private getStoredUser() {
    const userId = localStorage.getItem('userId');
    const userType = localStorage.getItem('userType');
    return userId ? { userId, userType } : null;
  }

  setUser(user: any) {
    localStorage.setItem('userId', user.userId);
    localStorage.setItem('userType', user.userType);
    this.userSubject.next(user);
  }

  clearUser() {
    localStorage.clear();
    this.userSubject.next(null);
  }
}
